import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import RegistrationForm from "./RegistrationForm";
import Confirm from "./Confirm";
import {
  postRegistration,
  postVerificationCode,
} from "../../../services/auth/registrationService";
import TokenService from "../../../services/token.service";
import bilAPI from "../../../services/api";
import { UserContext } from "../../../utils/contexts/UserContext";
import { toast } from "react-toastify";

export default function Registration() {
  const [step, setStep] = useState(1);
  const [t] = useTranslation();

  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);
  const [username, setUsername] = useState(null);

  const onSubmitRegistration = async (data) => {
    setError(null);
    setLoading(true);
    setUsername(data.iin);

    await postRegistration(data)
      .then((res) => {
        setStep(2);
      })
      .catch((err) => {
        let errorHandled = false;
        if (err.response.data.email?.code === "ALREADY_EXISTS") {
          errorHandled = true;
          setError(t("signup.email_is_taken"));
          toast.error(t("signup.email_is_taken"));
        }
        if (err.response.data.username?.code === "ALREADY_EXISTS") {
          errorHandled = true;
          setError(t("signup.iin_is_taken"));
          toast.error(t("signup.iin_is_taken"));
        }
        if (!errorHandled) {
          setError("Something went wrong");
          toast.error("Something went wrong");
          console.log(err.response.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getAccountInfo = async () => {
    try {
      const response = await bilAPI.get("/auth/my_account/", {});

      await setUser(response.data);
      navigate("/my-team", { replace: true });
    } catch (err) {
      console.error("Account info error:", err);
      setError(
        err.response?.data?.detail || t("auth.failed_to_get_account_info")
      );
      // If account info fails, remove tokens
      await TokenService.removeTokens();
    }
  };

  const onSubmitConfirm = async (data) => {
    const code = Object.values(data).join("");
    setLoading(true);
    setError(null);
    postVerificationCode({ code })
      .then(async (res) => {
        console.log(res);
        await TokenService.updateLocalAccessToken(res.access);
        if (res.refresh) {
          await TokenService.updateLocalRefreshToken(res.refresh);
        }

        // Set API header
        bilAPI.defaults.headers["Authorization"] = "Bearer " + res.access;
        // Get account info and navigate
        await getAccountInfo();
      })
      .catch((err) => {
        console.log(err.response.data);
        if (err.response.data.code === 1) {
          setError(t("signup.code_is_invalid_or_expired"));
        } else {
          setError(err.response.data.detail);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const links = [
    {
      text: t("signup.forgot_password"),
      onClick: () => navigate("/password-reset"),
    },
    {
      text: t("signup.already_have_account"),
      onClick: () => navigate("/login"),
    },
  ];

  useEffect(() => {
    setTimeout(() => {
      navigate("/login");
    }, 3000);
  }, [navigate]);

  return (
    <div>
      <div className="flex justify-center items-center h-screen">
        <h1 className="text-2xl font-bold">Регистрация жабық</h1>
      </div>
      {/* {step === 1 && (
        <RegistrationForm
          onSubmit={onSubmitRegistration}
          error={error}
          loading={loading}
          links={links}
        />
      )}
      {step === 2 && (
        <Confirm
          onSubmit={onSubmitConfirm}
          error={error}
          loading={loading}
          links={links}
          username={username}
          purpose={0}
        />
      )} */}
    </div>
  );
}
